import { createFileRoute } from '@tanstack/react-router';
import { t } from '@lingui/core/macro';
import { z } from 'zod';
import { supplyPointQueries } from '@/features/supply-points/queries';
import { organizationQueries } from '@/features/organizations/queries';
import { deviceQueries } from '@/features/devices/queries';
import { productQueries } from '@/features/products/queries';
import { FormPageSkeleton } from '@/common/components/loading-skeleton/FormPageSkeleton';
import { CreateSupplyPointPage } from '@/features/supply-points/pages/CreateSupplyPointPage';

const wizardSearchSchema = z.object({
  step: z.coerce.number().int().min(1).max(4).optional(),
  id: z.coerce.number().int().positive().optional(),
  orgId: z.coerce.number().int().positive().optional(),
});

export const Route = createFileRoute('/_authenticated/supply-points/new')({
  validateSearch: wizardSearchSchema,
  loaderDeps: ({ search }) => ({ step: search.step ?? 1, id: search.id }),
  loader: async ({ context: { queryClient }, deps: { step, id } }) => {
    await queryClient.ensureQueryData(supplyPointQueries.types());

    if (id !== undefined) {
      await Promise.all([
        queryClient.ensureQueryData(supplyPointQueries.accessList()),
        queryClient.ensureQueryData(supplyPointQueries.detail(id)),
        queryClient.ensureQueryData(organizationQueries.list()),
      ]);
    }

    if (step === 3 && id !== undefined) {
      await Promise.all([
        queryClient.ensureQueryData(deviceQueries.list()),
        queryClient.ensureQueryData(deviceQueries.types()),
      ]);
    }

    if (step === 4 && id !== undefined) {
      await Promise.all([
        queryClient.ensureQueryData(productQueries.variants()),
        queryClient.ensureQueryData(productQueries.products(id)),
      ]);
    }

    return { breadcrumb: t`New supply point` };
  },
  pendingComponent: FormPageSkeleton,
  component: function SupplyPointWizardRoute() {
    const { step, id, orgId } = Route.useSearch();
    return <CreateSupplyPointPage step={step ?? 1} id={id} orgId={orgId} />;
  },
});
